<template>
	<div>
		<b-modal v-model="config.show" centered
			:title='"Error " + config.title'
			ok-title = "Bestätigen"
			cancel-title ="Abbrechen"
			cancel-disabled
		><!-- b-modal -->
			<div v-html="config.message"></div>
			<div class="card">
				<div v-if="config.error != null && config.error != ''" class="card-body">
					<p style="font: 16px Lucida Console;">{{config.error}}</p>
				</div>
			</div>
		</b-modal>
		
	</div>
</template>

<script>
	export default {
		props: ['value'],
		data() {
			return {
				show: false,
			}
		},
		computed: {
			config: function () {
				return this.value;
			}
		},
		watch: {
			config: function (n, o) {
				this.$emit("input", this.config);
			}
		}
	}
</script>